import type { Greeting } from '~/models/Greeting'
import type { GradeType } from '~/models/GradeType'
import { readonly, ref } from 'vue'
import { DateTime, Interval } from 'luxon'
import greetingsJson from '~/assets/greetings.json'

export function useGreetings(gradeType?: GradeType) {
  const greeting = ref<Greeting>({ text: '' })

  const greetings: Greeting[] = (greetingsJson as Greeting[]).map(g => ({
    ...g,
    grades: g.grades as GradeType[]
  }))

  function load() {
    const filtered = greetings.filter(validate)

    if (filtered.length === 0) {
      const fallbackFiltered = greetings.filter(g =>
        !gradeType || !g.grades || g.grades.includes(gradeType)
      )

      if (fallbackFiltered.length > 0) {
        greeting.value = fallbackFiltered[Math.floor(Math.random() * fallbackFiltered.length)]
      } else {
        greeting.value = greetings.length > 0
          ? greetings[Math.floor(Math.random() * greetings.length)]
          : { text: 'Hei!' }
      }
    } else {
      greeting.value = filtered[Math.floor(Math.random() * filtered.length)]
    }
  }

  function validate(greeting: Greeting) {
    if (gradeType && greeting.grades && !greeting.grades.includes(gradeType)) {
      return false
    }

    // Filter by time ranges
    if (greeting.timeranges) {
      const now = DateTime.now()
      const valid = greeting
        .timeranges
        .some(({ before = '23:59:59.99', after = '00:00' }) => {
          return Interval
            .fromDateTimes(DateTime.fromISO(after), DateTime.fromISO(before))
            .contains(now)
        })

      if (!valid)
        return false
    }

    return true
  }

  load()

  return {
    greeting: readonly(greeting)
  }
}
